module.exports = __webpack_public_path__ + "img/icon_a.653506f4.png";